import React from 'react';
import { Cog } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const OptimisationPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.achats.pages.optimisationPage.${key}`, opts);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Cog className="h-8 w-8 text-purple-400" />
            <h1 className="text-3xl font-bold text-white">{p('title')}</h1>
          </div>
          <p className="text-white/60">{p('subtitle')}</p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-12 text-center">
          <div className="inline-block p-6 bg-purple-500/10 rounded-full mb-6">
            <Cog className="h-16 w-16 text-purple-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-4">{p('card_title')}</h2>
          <p className="text-white/60 text-lg mb-6">
            {p('card_description')}
          </p>
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-purple-500/20 border border-purple-400/30 rounded-xl text-purple-300">
            <span className="animate-pulse">●</span>
            <span>{p('module_in_development')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptimisationPage;
